import React from 'react';
import ReactDOM from 'react-dom';

import '../styles/preorder.scss';

class Preorder extends React.Component{

	render(){
		return (<div className="preorder">
			<a href="#0"></a>
			</div>);

	}
}

export default Preorder;


// WEBPACK FOOTER //
// ./src/scripts/preorder.js